import {
  AppDivider,
  AppEmptyState,
  AppScreenScaffold,
  AppSearchField,
  AppTopBar,
} from '@core/designsystem';
import { NewClientDialog } from '@core/ui/NewClientDialog';
import type { ClientListItem } from './formatter';
import type { ClientsActions, ClientsState } from './useClients';
import './clients.css';

/**
 * Список клиентов — «Структура» §7.1.
 *
 * Поиск стоит прямо в шапке, а не за кнопкой: список клиентов растёт быстрее списка
 * дел, и через полгода это единственный способ найти нужного.
 */
export function ClientsScreen({
  state,
  actions,
  onOpenClient,
  creating = false,
  onCreatingChange,
}: {
  state: ClientsState;
  actions: ClientsActions;
  onOpenClient: (id: string) => void;
  creating?: boolean;
  onCreatingChange?: (creating: boolean) => void;
}) {
  return (
    <AppScreenScaffold
      topBar={<AppTopBar title="Клиенты" root />}
      overlay={
        creating ? (
          <NewClientDialog
            onDismiss={() => onCreatingChange?.(false)}
            onCreate={(draft) => {
              void actions.createClient(draft);
              onCreatingChange?.(false);
            }}
          />
        ) : null
      }
    >
      <div className="clients__search">
        <AppSearchField
          value={state.query}
          onChange={actions.setQuery}
          placeholder="Имя, телефон или почта"
        />
      </div>

      {state.clients.length === 0 && !state.isLoading ? (
        <AppEmptyState
          icon="group"
          text={state.query ? 'Никого не нашлось' : 'Клиентов пока нет'}
        />
      ) : null}

      <div className="clients__list">
        {state.clients.map((client) => (
          <div key={client.id}>
            <ClientRow item={client} onOpen={() => onOpenClient(client.id)} />
            <AppDivider withIcon />
          </div>
        ))}
      </div>
    </AppScreenScaffold>
  );
}

/**
 * Строка клиента: кружок с инициалами, имя, дела и телефон.
 *
 * Кружок вместо фотографии — фотографий у нас нет и не будет: клиентов не фотографируют,
 * а пустая рамка на месте лица выглядела бы недоделкой.
 */
function ClientRow({ item, onOpen }: { item: ClientListItem; onOpen: () => void }) {
  return (
    <button type="button" className="client-row" onClick={onOpen}>
      <span className="client-row__avatar">{item.initials}</span>
      <span className="client-row__texts">
        <span className="client-row__name">{item.name}</span>
        <span className="client-row__meta">
          {item.phone ? `${item.casesLine} · ${item.phone}` : item.casesLine}
        </span>
      </span>
    </button>
  );
}
